export const PresentIcon = () => {
  return (
    <svg fill="none" height="10" viewBox="0 0 10 10" width="10" xmlns="http://www.w3.org/2000/svg">
      <path
        clipRule="evenodd"
        d="M7.397 2.806h1.978c.345 0 .625.28.625.625v.938c0 .172-.14.312-.313.312H5.625v-1.25h-1.25v1.25H.312C.14 4.681 0 4.541 0 4.37V3.43c0-.344.28-.625.625-.625h1.978c-.142-.097-.264-.193-.35-.28-.503-.506-.503-1.33 0-1.838.49-.492 1.344-.492 1.834 0 .27.272.99 1.379.89 2.118h.045c-.099-.74.62-1.846.891-2.118.49-.492 1.343-.494 1.833 0 .505.507.505 1.332 0 1.839-.085.086-.207.182-.349.28zm-3.175 0c.09 0 .116-.02.116-.02.146-.15-.273-1.233-.694-1.657C3.517 1 3.349.93 3.17.93c-.18 0-.347.07-.474.198-.262.264-.262.694 0 .957.27.272 1.094.72 1.526.72zm1.44-.02s.026.02.115.02c.432 0 1.257-.448 1.526-.72.263-.263.263-.693 0-.957-.254-.256-.695-.255-.947 0-.421.424-.84 1.506-.694 1.657zM.625 5.306v3.75c0 .345.468.625 1.042.625H8.75c.345 0 .625-.28.625-.625v-3.75H.625z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};
